import React, { useContext } from 'react'
import { func } from 'prop-types'
import styled from '@emotion/styled'
import { SiteConfigContext } from '../SiteConfigProvider'
import { Link } from '@jelly/ui'

// Styled Components via Emotion
const SectionWrapper = styled.nav`
	display: none;
	z-index: 1;
	background-color: none;

	${({ theme }) => theme.MQ.S} {
		display: flex;
		align-items: center;
		height: auto;
		padding-top: 20px;
		position: absolute;
		width: 100%;
	}
`
export const Element = styled.li`
	display: none;
	list-style-type: none;
	margin-right: 40px;

	${({ theme }) => theme.MQ.L} {
		display: block;
	}
`
export const ElementIcon = styled.li`
	align-items: center;
	display: flex;
	list-style-type: none;
	margin-right: 1rem;

	${({ theme }) => theme.MQ.XS} {
		margin-right: 1.5rem;
	}
`

export const StyledLink = styled(Link)`
	color: ${({ theme }) => theme.colors.white};
	font-size: 13px;
	${({ theme }) => theme.fonts.secondary};
	letter-spacing: 3px;
	line-height: 25px;
	height: 25px;
	text-transform: uppercase;
	.inverse & {
		color: ${({ theme }) => theme.navigation.linkColor};
	}
	&:hover {
		color: ${({ theme }) => theme.navigation.linkHoverColor};
	}
	/* These Styles are for Stand Alone Links in Nav Bar ex: COVID-19 Resources */
	${({ isHighlighted, theme }) =>
		isHighlighted &&
		`background-color: ${theme.colors.secondary};
		color: ${theme.colors.primary};
		font-weight: 600;
		padding: 8px 18px;
		transition: all 0.4s ease;

		&:hover {
			background: ${theme.colors.tertiary};
			color: ${theme.colors.white};
		}`}
`
export const IconWrapper = styled.div`
	background: ${({ theme, status }) => status && theme.colors.white};
	border-radius: 50%;
	height: 20px;
	cursor: pointer;
	padding: 2px;
	width: 20px;
	.inverse & {
		svg {
			circle,
			line,
			path {
				stroke: ${({ isLoggedIn, theme }) =>
					isLoggedIn ? theme.colors.secondary : theme.navigation.linkColor};
			}
		}
	}

	&:hover {
		svg {
			line,
			path {
				stroke: ${({ theme }) => theme.navigation.linkHoverColor};
			}
		}
	}
`

/**
 * Navigation Component:
 * This component should appear at the top of the parent in the right hand corner
 * Displays 3 core value CTAs, search function and account status + dropdown
 * Nav bar disappears on devices smaller than 420px
 *
 * Calls: the UserNav component
 *
 * TODO: this whole compoennt will be deprecated after the new header is rolled out
 */
export function Navigation({ handleSearchNavClick, isOverlappingHero = false }) {
	const {
		siteComponents: { NavigationLinks },
	} = useContext(SiteConfigContext)
	return (
		<SectionWrapper>
			<NavigationLinks handleSearchNavClick={handleSearchNavClick} isOverlappingHero={isOverlappingHero} />
		</SectionWrapper>
	)
}
Navigation.propTypes = {
	handleSearchNavClick: func,
}
